import * as BudgetActions from './budget';
import * as VehiclesModelActions from './vehiclesModel';
import * as VehiclesMaintenanceActions from './vehiclesMaintenance';
import * as ManageColorsActions from './manageColors';
import * as ManageColorsFormActions from './manageColorsForm';
import * as VehiclesHistoryColor from './vehiclesHistoryColor';
import * as VehiclesPriceColor from './vehiclesPriceColor';
import * as VehiclesPriceColorLoad from './vehiclesPriceColorLoad';
import * as AdvisorManagement from './advisorManagement';
import * as ClientManagement from './clientManagement';
import * as ExemptionManagement from './exemptionManagement';
import * as ManageFloatClientFiles from './manageFloatClientFiles';

const Actions = {
  ...BudgetActions,
  ...VehiclesModelActions,
  ...VehiclesMaintenanceActions,
  ...ManageColorsActions,
  ...ManageColorsFormActions,
  ...VehiclesHistoryColor,
  ...VehiclesPriceColor,
  ...AdvisorManagement,
  ...ClientManagement,
  ...ExemptionManagement,
  ...ManageFloatClientFiles,
  ...VehiclesPriceColorLoad,
};

export default Actions;
